import {
  LandingMinimal,
  LandingMinimalHelpsProps
} from '../../../../components/_external-pages/landing';

const props: LandingMinimalHelpsProps = {
  title: 'Creemos en las segundas oportunidades y seremos tu aliado de inicio a fin.',
  cards: [
    {
      description: 'Generamos soluciones eficientes que aporten valor a nuestros clientes.',
      title: 'Innovación'
    },
    {
      description: 'Asumimos los resultados de nuestros compromisos.',
      title: 'Responsabilidad'
    },
    {
      description:
        'Comunicamos de forma pertinente los términos y condiciones de nuestros procesos.',
      title: 'Transparencia'
    },
    {
      description:
        'Creamos ventajas competitivas en ahorro de tiempo y costos en nuestros procesos.',
      title: 'Integridad'
    },
    {
      description:
        'Nos apropiamos de la misión de la empresa como nuestra para alcanzar nuestros objetivos.',
      title: 'Compromiso'
    },
    {
      description: 'Buscamos brindar en todo momento calidad del servicio prestado.',
      title: 'Excelencia'
    }
  ]
};

export const AboutCards = () => {
  return <LandingMinimal {...props} />;
};
